import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BranchService } from 'src/app/services/branch.service';
import { FormServices } from 'src/app/services/form-services.service';
import { HttpService } from 'src/app/services/http.service';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.page.html',
  styleUrls: ['./contact.page.scss'],
})
export class ContactPage implements OnInit {
  fieldForms: any;
  domainId = environment.domainId;
  logo: string;
  isUploading = false;
  savedForm: any;
  id = undefined;
  imgFile: string = '';
  sending = false;

  constructor(
    public paramSv: ParamServicesService,
    public branchSv: BranchService,
    private formSv: FormServices,
    private httpSv: HttpService,
    private uiSv: UiServices,
    private trSv: TranslateService
  ) {}

  async ngOnInit() {
    try {
      if (!this.branchSv.branches.length) {
        await this.branchSv.getBranchs();
      }
      const res = await this.formSv.getForm('Contact', this.domainId);
      const bgImage: any[] = await this.paramSv.getImages('9');
      const contactImage = bgImage.find((item) => item.name === 'contact');

      if (this.paramSv.savedLogo.length) {
        this.setLogo();
      } else {
        const subsParam = this.paramSv.emitImagesObs.subscribe((item: any) => {
          if (item.name === 'logo') {
            this.setLogo();
            subsParam.unsubscribe();
          }
        });
      }

      if (contactImage) {
        this.imgFile = contactImage?.images[0]?.file;
      }
      this.fieldForms = res;
      this.setLogo();
    } catch (err) {
      console.error(err);
    }
  }

  setLogo() {
    const { logo } = this.paramSv.setLogo('Login');
    this.logo = logo;
  }

  async sendInfo(ev: FormData) {
    try {
      this.id && ev.set('id', String(this.id));
      ev.set('domainId', String(this.domainId));
      this.isUploading = true;
      this.sending = true;
      const res: any = await this.httpSv.itemAction(
        ev,
        'client/contacts',
        this.id ? 'update' : 'store'
      );
      this.isUploading = false;
      const tr = this.trSv.instant('ENVIADO_EXITOSAMENTE');
      this.uiSv.showToast(tr);
      if (res.status) {
        // this.id = res.data.id;
        this.id = undefined;
        this.formSv.clearFormSrc.next();
        this.formSv.deleteListProductSrc.next('reloadListProduct');
      }
      this.sending = false;
    } catch (err) {
      console.error(err);
      this.sending = false;
    }
  }
}
